export const utilityConstants = {

    SET_QUERY_PARAM: 'SET_QUERY_PARAM',
    GET_QUERY_PARAM: 'GET_QUERY_PARAM',

}